import { Pagination, styled } from '@mui/material'

export const StyledPagination = styled(Pagination)(() => ({
  width: 'fit-content',
  margin: 'auto',
}))
